export default function(value ,scale) {
  if(value === ''){
    return value;
  }
  const n = Number(value);
  if(isNaN(n)){
    return value;
  }
  if(!scale){
    scale = 0;
  }  
  const srcVal = n.toFixed(scale);
  let index = srcVal.indexOf('.');
  if(index === -1){
    index = srcVal.length;
  }
  let indexNeg = srcVal.indexOf('-');
  let firstMatch = true;
  return `${srcVal.replace(/./g, (c, i) => {//c, i, a
    let isAdd = i && i < index  && c !== '.' && ((index - i) % 3 === 0);
    if(indexNeg === 0){//有負號
      if(isAdd && ((index-1) % 3 === 0) && firstMatch){
        isAdd=false;
        firstMatch = false;
      }
    }
    const currency = (isAdd ? `, ${c}`.replace(/\s/g, '') : c);
    return currency;
  })}`;
}